<template>
<div :class="`input-date ${disabled ? 'disabled' : ''}`">
  <input :type="type" :id="theid" :value="value" :disabled="disabled" @input="$emit('input', $event.target.value)" />
  <label class="icon" :for="theid">
    <i :class="`icon-${icon}`" />
  </label>
</div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'event',
    },
    type: {
      type: String,
      default: 'date',
      validator: value => ['date', 'datetime-local'].indexOf(value) !== -1,
    },
    value: {
      type: String,
      default: new Date(),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: String,
      default: '',
    },
    max: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      theid: '',
    };
  },
  mounted() {
    this.theid = this.id ? this.id : Math.trunc(Date.now() / Math.floor(Math.random() * 100));
  },
};
</script>

<style lang="scss" scoped>
.input-date {
  background: #FFFFFF;
  border: 1px solid #D7D9E0;
  position: relative;

  &:not(.disabled):not(.readonly) {
    input {
      &:hover {
        cursor: pointer;
      }
    }
  }

  &.disabled {
    opacity: .5;
  }

  input {
    font-size: 16px;
    line-height: 32px;
    padding: 0 0 0 10px;
    outline: none;
  }

  .icon {
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    border-left: 1px solid #D7D9E0;
    box-shadow: inset -2px -2px 0 0 #E8EEF2;
    display: flex;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    pointer-events: none;
    color: #0060FF;
    width: 32px;
    margin-bottom: 0;

    i {
      font-size: 18px;
      pointer-events: none;
    }

    &:hover {
      cursor: pointer
    }
  }
}
</style>
